/**
 * Retrieves the current time for display.
 */
export function getTime() {
    const now = new Date();
    let hours = now.getHours();
    const minutes = now.getMinutes();
    let dn = 'AM';
    if (hours >= 12) {
        dn = 'PM';
        hours = (hours - 12);
    }
    if (hours == 0) {
        hours = 12;
    }
    let displayMinutes = minutes.toString();
    if (minutes < 10) {
        displayMinutes = ('0' + minutes);
    }
    return `${hours}:${displayMinutes} ${dn}`;
}
/**
 * Retrieves the current date for display.
 */
export function getDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1);
    const date = now.getDate();
    return `${month}/${date}/${year}`;
}
